<template>
  <div>
    <v-data-table
      dense
      :headers="headers"
      :items="history"
      :items-per-page="-1"
      hide-default-footer
    >
      <template v-slot:[`item.Actions`]="{ item }">
        <v-btn
          v-if="isFinancier"
          small
          text
          plain
          color="primary"
          class="my-2"
          @click="showRateHistoryDetails(item.Project_ID)"
        >
          details...
        </v-btn>
      </template>
    </v-data-table>
    <v-dialog
      v-if="isFinancier"
      max-width="400px"
      v-model="showRateHistoryDialog"
      scrollable
    >
      <v-card>
        <v-card-title>
          Rate History
          <v-spacer></v-spacer>
          <v-btn
            icon
            blur
            @click.prevent="showRateHistoryDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-2">
          <v-data-table
            dense
            style="max-height: 500px"
            :headers="rateHistoryHeaders"
            :items="rateHistory"
            :items-per-page="-1"
            hide-default-footer
          >
          </v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            small
            color="primary"
            outlined
            @click="showRateHistoryDialog = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: 'EmployeeProjectsHistory',
  props: {
    employeeID: {
      required: true
    },
    rolesOfUser: {
      required: true
    }
  },
  data () {
    return {
      history: [],
      rateHistory: [],
      showRateHistoryDialog: false,
      rateHistoryHeaders: [
        {
          text: 'From Date',
          value: 'From_Date',
          divider: true,
          sortable: false,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap'
        },
        {
          text: 'Project Rate',
          value: 'Project_Rate',
          divider: true,
          sortable: false,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap'
        },
        {
          text: 'Employee Rate',
          value: 'Employee_Rate',
          sortable: false,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap'
        }
      ]
    }
  },
  computed: {
    headers () {
      return [
        {
          text: 'Project',
          value: 'Project_Name',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          show: true
        },
        {
          text: 'From Date',
          value: 'Date_From',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          show: true
        },
        {
          text: 'To Date',
          value: 'Date_To',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          show: true
        },
        {
          text: 'PM',
          value: 'Project_Manager_FullName',
          divider: this.isFinancier,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          show: true
        },
        {
          text: 'Project Rate',
          value: 'Project_Rate',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          show: this.isFinancier
        },
        {
          text: 'Employee Rate',
          value: 'Employee_Rate',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          show: this.isFinancier
        },
        {
          text: 'Rate Details',
          value: 'Actions',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          show: this.isFinancier
        }
      ].filter(el => el.show)
    },
    user () {
      return this.$store.getters.getUser
    },
    isFinancier () {
      const requiredRole = 'financier'
      return this.rolesOfUser.some(role => role.RoleName.toLowerCase() === requiredRole)
    }
  },
  mounted () {
    this.getHistory()
  },
  methods: {
    getHistory () {
      const body = { Is_Financier: this.isFinancier }
      this.axios.post(`/api/employee_projects_history/${this.employeeID}`, body, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(result => {
        this.history = result.data
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    showRateHistoryDetails (projectID) {
      if (!this.isFinancier) {
        return
      }
      this.axios.get(`/api/employee_project_rate_history/${projectID}/${this.employeeID}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(result => {
        this.rateHistory = result.data
        this.showRateHistoryDialog = true
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    }
  }
}
</script>
